"use strict";

exports.__esModule = true;
exports.AlertsToolbarSpace = exports.AlertsConditionConfigurationWrapper = exports.AlertsConditionConfigurationLabel = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Theme = require("../../Theme");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var AlertsConditionConfigurationWrapper = exports.AlertsConditionConfigurationWrapper = _styledComponents["default"].div.withConfig({
  displayName: "styles__AlertsConditionConfigurationWrapper",
  componentId: "sc-t6dzj8-0"
})(["flex:1 1 auto;position:relative;margin:auto;padding:15px;border-radius:10px;width:75%;background:", ";"], (0, _Theme.val)("ToolbarBackground"));
var AlertsConditionConfigurationLabel = exports.AlertsConditionConfigurationLabel = _styledComponents["default"].div.withConfig({
  displayName: "styles__AlertsConditionConfigurationLabel",
  componentId: "sc-t6dzj8-1"
})(["font-style:italic;font-weight:bold;"]);
var AlertsToolbarSpace = exports.AlertsToolbarSpace = _styledComponents["default"].div.withConfig({
  displayName: "styles__AlertsToolbarSpace",
  componentId: "sc-t6dzj8-2"
})(["margin-left:10px;"]);